export default __webpack_public_path__ + "static/5-5c02ed5f46c684306af451a9ae3ce77b.jpg";